module.exports = __webpack_public_path__ + "static/media/logo_wooribank.aa1d9061.svg";